/**
 * Encoding of the auction group text (VerstGruppeText) for use as a URL path segment.
 *
 * The app uses HashRouter with hashType 'slash', whose encodePath does NOT percent-encode
 * the hash. Combined with history v4 running decodeURI() on location.pathname for every
 * push/replace, any raw "%" in a path segment (e.g. from "DEKOMAT. H% MEHRW") becomes an
 * invalid percent-escape and throws a URIError, crashing the page.
 *
 * encodeURIComponent does not help: it produces "%25", which HashRouter writes into the
 * hash unencoded and which then breaks decodeURI on the way back.
 *
 * We therefore encode the value as a hex string ([0-9a-f]+). Hex contains no "%", no
 * reserved URL characters and no whitespace, so it is a fixed point of decodeURI and is
 * never mangled by the browser's hash handling. It round-trips through HashRouter safely.
 *
 * (The group text is the identifier because the numeric VerstGruppe is n:1 to the text and
 * therefore not a stable key for a group.)
 */

// UTF-8 safe: encodeURIComponent yields UTF-8 %-escapes, unescape turns them into a
// byte string, which we render as two hex chars per byte. IE11-safe (no padStart).
export const encodeVstGrp = (value: string): string => {
  const bytes = unescape(encodeURIComponent(value));
  let hex = '';
  for (let i = 0; i < bytes.length; i++) {
    hex += ('0' + bytes.charCodeAt(i).toString(16)).slice(-2);
  }
  return hex;
};

export const decodeVstGrp = (token: string): string => {
  const pairs = token.match(/../g);
  if (!pairs) {
    return token;
  }
  let bytes = '';
  for (const pair of pairs) {
    bytes += String.fromCharCode(parseInt(pair, 16));
  }
  try {
    return decodeURIComponent(escape(bytes));
  } catch (e) {
    return bytes;
  }
};
